import { GameRuneLuckImg, GameRuneSpeedImg, GameRuneStaminaImg } from "@/assets"
import { IRuneType } from "."

export const runeImageTypeMap: Record<IRuneType, string> = {
  speed: GameRuneSpeedImg,
  luck: GameRuneLuckImg,
  stamina: GameRuneStaminaImg
}
